/**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from '@/store'

// export default {
//   inserted(value) {
//     console.log(value, '------------------哈哈哈哈哈')
//     // const {value} = binding
//     const all_permission = "*:*:*";
//     const permissions = store.getters && store.getters.permissions
//
//     if (value && value instanceof Array && value.length > 0) {
//       const permissionFlag = value
//
//       const hasPermissions = permissions.some(permission => {
//         return all_permission === permission || permissionFlag.includes(permission)
//       })
//
//       if (!hasPermissions) {
//        return true
//       }
//     } else {
//       return false
//     }
//   }
// }
export default {
  // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function (Vue) {
    Vue.prototype.hasPermiFn = (param) => hasPermiFn(param)
  }
}
function hasPermiFn (value) {
  const all_permission = "*:*:*";
  const permissions = store.getters && store.getters.permissions

  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value

    const hasPermissions = permissions.some(permission => {
      return all_permission === permission || permissionFlag.includes(permission)
    })
    return !hasPermissions
    // if (!hasPermissions) {
    //   return false
    // }
    // return true
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermiFn.js